import ModelCheck from "../model/ModelCheck";
import axios from "axios"

const DNS = "https://kitlegit.com/api/v1"
const DNS_NO_API = "https://kitlegit.com"


class Apis {


    static headers() {
        return {
            "Content-Type": "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
        }
    }
    
    static async  fetchData(certificate_id) {
        try {
            let data = await axios.get(`${DNS}/productbycertificate/${certificate_id}`)
            return new ModelCheck().fromJson(data.data);
        } catch (error) {
            throw new Error("Error fetching")
        }
    }

    static async downloadPDF(check_certificate) {
        const apiUrl = `${DNS_NO_API}/storage/certificates/${check_certificate}.pdf`; // Replace with your API endpoint
        const downloadLink = document.createElement('a');
        
        fetch(apiUrl)
            .then(response => response.blob())
            .then(blob => {
                // Create a Blob from the response data
                const url = window.URL.createObjectURL(blob);
            
                // Set up the download link
                downloadLink.href = url;
                downloadLink.download = `${check_certificate}.pdf`; // Replace with the desired file name
            
                // Append the download link to the document
                document.body.appendChild(downloadLink);
            
                // Trigger the click event on the download link
                downloadLink.click();
            
                // Clean up: remove the download link and revoke the Blob URL
                document.body.removeChild(downloadLink);
                window.URL.revokeObjectURL(url);
                
            }).catch(error => console.error('Error downloading PDF file:', error));             

    }
}
export default Apis